import { render, staticRenderFns } from "./DetalleIngresoAdicional.vue?vue&type=template&id=84c6945a"
import script from "./DetalleIngresoAdicional.vue?vue&type=script&lang=js"
export * from "./DetalleIngresoAdicional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c6945a')) {
      api.createRecord('84c6945a', component.options)
    } else {
      api.reload('84c6945a', component.options)
    }
    module.hot.accept("./DetalleIngresoAdicional.vue?vue&type=template&id=84c6945a", function () {
      api.rerender('84c6945a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/DetalleIngresoAdicional.vue"
export default component.exports